import { Box, Typography } from "@mui/material";
import { useStyles } from "./styles";
import { icons } from "../../../../utils/icons";


interface CatalogQuestionDetailProps {
    list: {
        text: string | null;
        base: string;
        values: string[]
    }[]
}


export const CatalogQuestionDetail = ({ list }: CatalogQuestionDetailProps) => {

    const styles = useStyles()

    const getSubNames = (configAnswer: string[], subCategorytext: string) => {

        const names = configAnswer.map(item => item);

        const result = names.join(" / ");

        const resultWithText = configAnswer.length ? `${result} ${subCategorytext.trim().length > 0 ? ` : ${subCategorytext}` : ''}` : subCategorytext.trim().length > 0 ? subCategorytext : ''

        return (
            <Box sx={styles.dropList}>
                <Typography variant="body2">
                    {resultWithText}
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={styles.topContainer}>
            <Box sx={styles.categoriesContainer}>
                {list.map(item => (
                    <Box sx={styles.mainContainer((item.values ?? []).length > 0 || (item.text ?? '')?.trim().length > 0)}>
                        <Box sx={styles.iconSetting} >{icons('setting')}</Box>

                        <Box sx={styles.superior}>
                            <Typography variant="subtitle1" fontWeight="bold">{item.base}</Typography>

                            <Box>
                                {(item.values || (item.text ?? '')?.trim().length > 0) && (<>{getSubNames(item.values ?? [], item.text ?? '')}</>)}
                            </Box>
                        </Box>

                    </Box>
                ))}
            </Box>
        </Box>
    );
};